module.exports = __webpack_public_path__ + "static/media/pic26.642eb054.jpg";